module.exports = __webpack_public_path__ + "img/sunny.9276af0f.png";